import { useMutation, useRequest } from "@umijs/max";
import React, {useState, useEffect} from 'react';
import {
  EyeOutlined,
  LeftOutlined,
  HistoryOutlined,
} from '@ant-design/icons';


const planDetailsState = () => {
    // 状态数据流
    const [isReduction, setIsReduction] = useState(false); // 是否还原
    const [isReturn, setIsReturn] = useState(false); // 禁止图片回调
    const [creativeProposalList, setCreativeProposalList] = useState<any>([]); // 创意方案列表
    const [activeIndex, setActiveIndex] = useState<any>(0); // 当前激活的创意方案索引
    const [hotspotSchemeImageInfoList, setHotspotSchemeImageInfoList] = useState<any>([]);// 当前展示方案的图片
    const [insertImage, setInsertImage] = useState<any>(null); // 插入图片
    const [seoText, setSeoText] = useState('');
    const [newFlag, setNewFlag] = useState(false); // 是否为新方案
    const [codeValue, setCodeValue] = useState({}); // 编辑器编辑数据
    const [newImg, setNewImg] = useState(false); // 是否操作图片
    const [withPictures, setWithPictures] = useState([]); // 生成画面数据
    const [optimizationPlan, setOptimizationPlan] = useState<any>(null);
    const [historicalRecordsList, setHistoricalRecordsList] = useState<any>([]);
    const [reductionData, setReductionData] = useState<any>({}); // 还原数据
    const [isHistoricalRecords, setIsHistoricalRecords] = useState(false); // 是否还原历史记录
    const [drawerDataIndex, setDrawerDataIndex] = useState(0); // 0:历史 1:预览
    const [calendarAnalysis, setCalendarAnalysis] = useState<any>({
      advice: '',
      matching_degree: '',
      risk: '',
      relevance: '',
    }); // 日历分析数据
    const [productsId, setProductsId] = useState<any>(''); // 产品ID
    const [hotSpotInformation, setHotSpotInformation] = useState<any>({
      brandListName: '',
      inspiration: '',
      hotspotDetail: '',
      advice: '',
    });
    const [generateGraph, setGenerateGraph] = useState<any>([]); //生成图数据
    const planDetailsData: any = {
      timerRef: null,
      ifCalendar: false,
    }
    // 主界面 planPage 数据流
    const planPage: any = {
      drawerData: [
        { label: '历史', active: true, icon: <HistoryOutlined style={{ fontSize: '18px' }} className='card-outlined-icon' /> },
        { label: '预览', active: false, icon: <EyeOutlined style={{ fontSize: '18px' }} className='card-outlined-icon' /> },
      ]
    }
    const [smartPushList, setSmartPushList] = useState<any>([]); // 智能推送列表


    

  return {
    setSeoText,
    seoText,
    setNewFlag,
    newFlag,
    setOptimizationPlan,
    optimizationPlan, 
    setHistoricalRecordsList,
    historicalRecordsList,
    setNewImg,
    newImg,
    setReductionData,
    reductionData,
    setIsHistoricalRecords,
    isHistoricalRecords,
    setCalendarAnalysis,
    calendarAnalysis,
    codeValue, setCodeValue,
    generateGraph, setGenerateGraph,
    creativeProposalList, setCreativeProposalList,
    activeIndex, setActiveIndex,
    hotspotSchemeImageInfoList, setHotspotSchemeImageInfoList,
    insertImage, setInsertImage,
    drawerDataIndex, setDrawerDataIndex,
    planDetailsData,
    withPictures, setWithPictures,
    planPage,
    isReturn, setIsReturn,
    isReduction, setIsReduction,
    smartPushList, setSmartPushList,
    hotSpotInformation, setHotSpotInformation,
    productsId, setProductsId,
  }
};

export default planDetailsState;
